export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.hook('page:finish', () => {
        if (window?.parent?.postMessage) {
            window.parent.postMessage({ type: 'frameReady', ready: true }, '*')
        }
    })
})